export function sendAdmEventTracking(ownerTenantId) {
  try {
    const uifData = localStorage.getItem("__uif");
    const uidValue1 = uifData && uifData.match(/__uid:(\d+)/) ? uifData.match(/__uid:(\d+)/)[1] : "";
    const uidac1 = localStorage.getItem("__uidac") || "";

    function getCookieValue(name) {
      var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
      return match ? match[2] : "";
    }

    const Location1 = getCookieValue("__RC") || "";
    const fullPath1 = encodeURIComponent(location.pathname + location.search);
    const xtrlog = btoa(JSON.stringify({ type: "pc", userId: ownerTenantId })) || "";
    let newImg = new Image();
    newImg.src = `https://lg1.logging.admicro.vn/tl?dt=1&ii=page_view&d=https://manage.bizflycloud.vn/&p=${fullPath1}&lsn=1685608045998&ce=1&lc=${Location1}&cr=1685525886&ui=${uidValue1}&dg=${uidac1}&xtr=${xtrlog}`;
  } catch (error) {
    console.error(error);
  }
}

export function initTreasureTracking(ownerProjectId) {
  const script = document.createElement("script");
  script.innerHTML = `
    var td = new Treasure({
      host: 'us01.records.in.treasuredata.com',
      writeKey: '12734/3d946893a194a38d1b372efb06ecf08c76bd6759',
      database: 'bizfly_tracking'
    });
    td.set('$global', 'td_global_id', 'td_global_id');
    td.set('pageviews', {user_project_id: '${ownerProjectId}'});
    td.setSignedMode();
  `;
  document.head.appendChild(script);
}
